<template>
  <div
    class="payment-lookup"
  >
    <div class="modal" id="payment-lookup-modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">PayPal Purchase ({{ this.paymentId }})</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
            <div class="modal-body">
              <flash></flash>
              <spinner size="large" v-if="base.loading" />
              <div
                v-if="purchase && !base.loading"
              >
                <p
                  class="alert alert-danger text-center"
                  v-if="!purchase.id && purchase.purchased_at"
                >
                  Gift information is not included with PayPal transaction info.
                </p>
                <div
                  v-else-if="purchase.id"
                >
                  <p
                    class="alert alert-danger text-center"
                  >
                    A purchase record for this payment already exists!
                  </p>
                  <router-link
                    :to="{
                      name: 'purchase',
                      params: {
                        purchaseId: purchase.id
                      }
                    }"
                    class="form-group btn btn-primary btn-block"
                    data-dismiss="modal"
                  >
                    View Full Purchase Record
                  </router-link>
                </div>
                <purchase
                  hide-header
                  no-lookup
                  payment-only
                />
              </div>
              <p
                class="alert alert-danger"
                v-else-if="!base.loading"
              >
                No requests logged
              </p>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-info"
                v-on:click.prevent="lookupPayment"
              >
                Refresh
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >Close</button>
            </div>
        </div>
      </div>
    </div>

    <button
      class="btn btn-primary btn-block"
      id="payment-lookup-btn"
      data-toggle="modal"
      data-target="#payment-lookup-modal"
      v-on:click.prevent="lookupPayment"
    >
      Search PayPal Records by ID ({{ this.paymentId }})
    </button>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner'

import Flash from '@/components/Flash'
import Purchase from '@/components/Purchase'

import FlashStore from '@/stores/FlashStore'

import { mapState } from 'vuex'

export default {
  props: {
    paymentId: {
      type: String,
      default: undefined,
      required: true
    }
  },

  components: {
    'flash': Flash,
    'purchase': Purchase,
    'spinner': Spinner
  },

  computed: mapState({
    base: state => state.base,
    purchase: state => state.PurchaseModule.purchase
  }),

  methods: {
    lookupPayment () {
      FlashStore.clear()
      this.$store.dispatch(
        'PurchaseModule/paymentLookup', this.paymentId
      ).catch(this.$root.processErrors)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PaymentLookup.vue